import axios from "axios";
import { createHeaders } from "./Constant";
 
const hostname = window.location.hostname;
const isLocal = hostname === "localhost" || hostname === "127.0.0.1";

const baseMap = {
  "customer-test.finhub.habilelabs.io": "/vkyc-backend/api",
  "endpoint-gateway-test.finhub.habilelabs.io": "https://endpoint-gateway-test.finhub.habilelabs.io/vkyc-backend",
};

const backendBase = isLocal
  ? "http://localhost:8000"
  : baseMap[hostname] || "https://endpoint-gateway-test.finhub.habilelabs.io/vkyc-backend"; 

console.log('LivelinessService - Hostname:', hostname);
console.log('LivelinessService - Is Local:', isLocal);
console.log('LivelinessService - Base URL:', backendBase);

export const LivelinessService = {
  detectLiveliness: async (videos, sessionId, requestId, customerSession) => {
    console.log('\n=== LIVELINESS SERVICE API CALL ===');
    console.log('LivelinessService.detectLiveliness - session_id being sent:', sessionId);
    console.log('LivelinessService.detectLiveliness - request_id being sent:', requestId);
    console.log('LivelinessService.detectLiveliness - API endpoint:', `${backendBase}/api/v1/face-liveliness/`);
    console.log('LivelinessService.detectLiveliness - Number of videos received:', videos.length);
    
    // Validate videos before processing
    if (!videos || videos.length !== 3) {
      throw new Error(`Expected 3 videos, got ${videos?.length || 0}`);
    }
    
    console.log('Video validation:');
    videos.forEach((video, idx) => {
      if (!video || video.size === 0) {
        throw new Error(`Video ${idx + 1} is empty or invalid`);
      }
      console.log(`  Video ${idx + 1}: size=${video.size} bytes, type=${video.type}, valid=${video.size > 0}`);
    });
    
    const formData = new FormData();
    console.log('Creating FormData...');
 
    // Ensure exactly 3 videos are sent with correct field names
    formData.append('video1', videos[0], 'step1.webm');
    formData.append('video2', videos[1], 'step2.webm');
    formData.append('video3', videos[2], 'step3.webm');
    
    console.log('Added videos to FormData:');
    console.log(`  video1: ${videos[0].size} bytes`);
    console.log(`  video2: ${videos[1].size} bytes`);
    console.log(`  video3: ${videos[2].size} bytes`);
 
    formData.append("session_id", sessionId);
    formData.append("request_id", requestId);
    if (customerSession) formData.append("session", customerSession);
    console.log('Added session_id, request_id and applicant_id to FormData');
    
    console.log('Sending POST request to:', `${backendBase}/api/v1/face-liveliness/`);
    const startTime = Date.now();
    
    try {
      const response = await axios.post(
          `${backendBase}/api/v1/face-liveliness/`,
          formData,
          {
              headers:{
                  ...createHeaders(),
                  'Content-Type': 'multipart/form-data',
                  'session': customerSession
              }
          }
      );
      
      const endTime = Date.now();
      console.log(`\n✅ API call successful! (${endTime - startTime}ms)`);
      console.log('Response status:', response.status);
      console.log('Response data:', response.data);
      console.log('=====================================\n');
      
      return response.data;
    } catch (error) {
      const endTime = Date.now();
      console.error(`\n❌ API call failed! (${endTime - startTime}ms)`);
      console.error('Error status:', error.response?.status);
      console.error('Error data:', error.response?.data);
      console.error('Error message:', error.message);
      console.log('=====================================\n');
      throw error;
    }
  },
};